export default (theme, themeCompare) => theme.toLowerCase() === themeCompare.toLowerCase();
